import React from 'react';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import i18n from 'i18n';
import BlockHeader from 'components/common/BlockHeader';
import Button from 'components/common/Button';
import {
  pcStyle as tablePCStyle,
  spStyle as tableSPStyle
} from 'components/OrderAggregators/styles/table';
import CustomerDialog from 'components/OrderAggregators/components/CustomerDialog';
import SessionManager from 'util/session-manager';

class Customer extends React.Component {
  constructor(props) {
    super(props);

    this.customerDialogRef = React.createRef();
  }

  handleCustomerDialogSave(props, value) {
    const { change } = props;
    change('customer', value);

    let storedData;
    try {
      storedData = SessionManager.load();
    } catch (error) {
      switch (error.name) {
        case 'NoSessionError':
        case 'SessionExpiredError':
        case 'LoadDataError':
          this.props.push('/error');
          return;

        default:
          throw error;
      }
    }
    storedData.customer = value;
    SessionManager.save(storedData);
  }

  render() {
    const { className, form } = this.props;
    const customer = form.getState().values.customer;

    if (!customer) return;

    return (
      <div className={className}>
        <BlockHeader>
          {i18n.t('orderAggregators:confirmation:customerInfo')}
        </BlockHeader>
        <table className="confirm-table">
          <tbody>
            <tr>
              <th>{i18n.t('orderAggregators:confirmation:name')}</th>
              <td>{customer.name}</td>
            </tr>
            <tr>
              <th>{i18n.t('orderAggregators:confirmation:nameKana')}</th>
              <td>{customer.nameKana ? customer.nameKana : '-'}</td>
            </tr>
            <tr>
              <th>{i18n.t('orderAggregators:confirmation:tel')}</th>
              <td>{customer.telephone}</td>
            </tr>
            <tr>
              <th>{i18n.t('orderAggregators:confirmation:email')}</th>
              <td>{customer.email}</td>
            </tr>
          </tbody>
        </table>
        <div className="btn-wrapper">
          <Button
            buttonType="F"
            type="button"
            onClick={() => this.customerDialogRef.current.open()}
          >
            {i18n.t('orderAggregators:confirmation:edit')}
          </Button>
        </div>
        <CustomerDialog
          dialogRef={this.customerDialogRef}
          onSubmit={v => this.handleCustomerDialogSave(this.props.form, v)}
          form={form}
        />
      </div>
    );
  }
}

const pcStyle = CustomMedia.greaterThan('umedium')`
  .btn-wrapper {
    width: 100%;
    margin: 24px 0 0;
    text-align: center;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .btn-wrapper {
    width: 100%;
    text-align: center;
    padding-top: 16px;
  }
`;

export default applyStyles(Customer)(
  pcStyle,
  spStyle,
  tablePCStyle,
  tableSPStyle
);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Confirmation/components/Customer.js